import { Button } from '@vimily/bonjoro-ui-components-v2/Button';
import React from 'react';
import { QueryStatus } from 'react-query';
import AttributeListItem from '~/BonjorosList/components/Todo/DetailsPanel/AttributeListItem';
import { useZiggy } from '~/react-hooks/use-ziggy';

import { Attribute } from '~/types/models';

export interface AttributeListProps {
  attributes: Attribute[];
  status: QueryStatus;
}

export default function AttributeList({
  attributes,
  status,
}: AttributeListProps) {
  const { route } = useZiggy();

  if (status == 'error') {
    return (
      <>
        There was a problem loading attributes. Please check your automation
        settings.
      </>
    );
  }

  if (status == 'loading') {
    return <i className='far fa-spinner fa-spin' />;
  }

  if (attributes.length === 0) {
    return (
      <div>
        <span className='body-copy'>
          View more information about this customer. &nbsp;
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='http://help.bonjoro.com/integrations-and-workflow/attributes-customise-your-bonjoros-with-crm-data'
          >
            See how
          </a>
        </span>
        <div className='mt-4'>
          <a href={route('automation::index')} className='!v2-text-black'>
            <Button variant='secondary'>Connect a new integration</Button>
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className='text-base flex flex-col gap-y-4'>
      {attributes.map((attribute) => (
        <AttributeListItem key={attribute.name} attribute={attribute} />
      ))}
    </div>
  );
}
